// extracted by mini-css-extract-plugin
module.exports = {"root":"SmarterFasterHeader__root--1qLdJ","text":"SmarterFasterHeader__text--3N0qs","bounce":"SmarterFasterHeader__bounce--1qsIu"};